<template>
    <div>
        <div class="clearfix mt-3"> <!-- Mustafijur removed: company-form-container -->
            <div class="py-2">
                <div class="col-sm-12 px-3 company-form-box-title">{{this.list_title}}</div></div>
            <div class="col-md-12 px-3 employee-table-wrapper">
            <table class="table border-0">
                    <thead>
                        <tr class="table-head">
                            <th class="border-0 align-top"><label class="mb-0">Date</label></th>
                            <th class="border-0 align-top"><label class="mb-0">Amount</label></th>
                            <th class="border-0 align-top"><label class="mb-0">Distribution Type</label></th>
                            <th class="border-0 align-top"><label class="mb-0">Details</label></th>
                            <th class="border-0 align-top"><label class="mb-0">Processed By</label></th>
                            <template v-if="$acl['pf/get-distribution-list'] > 1">
                            <th class="border-0 align-top"><label class="mb-0">Action</label></th>
                            </template>

                        </tr>
                    </thead>


                    <tbody>
                        <tr class="table-row hover-bg" v-for="(emp_application,index) in application_lists" :key="emp_application.id">

                            <td>{{emp_application.date_added}}</td>
                            <td class="text-right d-block">{{formatMoney(emp_application.amount)}}</td> <!-- Rejwan: 24-04-2025 2 decimal -->
                            <td>{{emp_application.type}}</td>
                            <td>{{emp_application.details}}</td>
                            <td>{{emp_application.processor_name}}</td>
                            <template v-if="$acl['pf/get-distribution-list'] > 1">
                            <td class='distribution_delete_show text-right'>


                                    <template v-if="index==0">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu p-1" aria-labelledby="actionDropdown">
                                        <b-button-group class="d-flex flex-column flex-grow-1">


                                            <template v-if="pf_settings.pf_profit_audit_feature.opt_value > 0">

                                                <template v-if="emp_application.status==1">
                                                    <b-button v-if="emp_application.status==1" class="text-left" @click="showConfirmModal(emp_application.id,2)" variant="outline-secondary">
                                                        <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon> Mark as Audited
                                                    </b-button>
                                                    <b-button class="text-left" @click="showDeleteModal(emp_application.id)" variant="outline-secondary">
                                                        <b-icon icon="trash" aria-hidden="true"></b-icon>Delete
                                                    </b-button>
                                                </template>
                                                <template v-if="emp_application.status==2">
                                                    <b-button v-if="emp_application.status==2" class="text-left" @click="showConfirmModal(emp_application.id,1)" variant="outline-secondary">
                                                        <b-icon icon="check-circle-fill" variant="warning" aria-hidden="true" ></b-icon> Mark as Draft
                                                    </b-button>
                                                </template>

                                            </template>
                                            <template v-if="pf_settings.pf_profit_audit_feature.opt_value == 0">

                                                <b-button class="text-left" @click="showDeleteModal(emp_application.id)" variant="outline-secondary">
                                                    <b-icon icon="trash" aria-hidden="true"></b-icon>Delete
                                                </b-button>

                                            </template>

                                        </b-button-group>
                                    </div>
                                    </template>
                                    <template v-else>
                                        <template>
                                            <a v-if="pf_settings.pf_profit_audit_feature.opt_value > 0" id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu p-1" aria-labelledby="actionDropdown">

                                                <template v-if="pf_settings.pf_profit_audit_feature.opt_value > 0">
                                                    <b-button-group class="d-flex flex-column flex-grow-1">
                                                        <b-button v-if="emp_application.status==1" variant="outline-secondary" class="text-left" @click="showConfirmModal(emp_application.id,2)">
                                                            <b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon> Mark as Audited
                                                        </b-button>
                                                        <b-button v-if="emp_application.status==2" variant="outline-secondary" class="text-left" @click="showConfirmModal(emp_application.id,1)">
                                                            <b-icon icon="check-circle-fill" variant="warning" aria-hidden="true" ></b-icon> Mark as Draft
                                                        </b-button>
                                                    </b-button-group>
                                                </template>
                                                <template v-if="pf_settings.pf_profit_audit_feature.opt_value == 0">

                                                </template>
                                            </div>
                                        </template>
                                    </template>

                            </td>
                        </template>
                        </tr>
                        <tr v-if="application_lists.length == 0"><td :colspan=8 class="text-center border">Currently no application available!</td></tr>
                    </tbody>
                    <tfoot v-if="application_lists.length != 0">
                    <tr>

                    </tr>
                    </tfoot>
                </table>
                <b-modal id="delete-modal" title="Are you sure you want to delete this Distribution ?" hide-footer>
                    <br />
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteDistribution(distribution_id)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>
                </b-modal>
                <b-modal id="confirm-modal" title="Are you sure you want to update this Distribution ?" hide-footer>
                    <br />
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="updateDistribution(distribution_id)">Mark as {{ statusOptions[mark_flag].text }}<span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('confirm-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>
                </b-modal>
                <b-modal id="confirm-payrun-modal" :title="payrun_delete_msg" hide-footer>Please enter your password to continue:
                    <br />
                    <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass">

                    <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="updateDistribution(distribution_id)">{{btn_name}} <span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('confirm-payrun-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>

                </b-modal>
                <b-modal id="delete-payrun-modal" :title="payrun_delete_msg" hide-footer>Please enter your password to continue:
                    <br />
                    <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass">

                    <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
                    <div style="height: 10px;clear:both;"> &nbsp;</div>
                    <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteDistribution(distribution_id)">{{btn_name}} <span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></a>
                    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-payrun-modal')">Cancel</a>
                    <div style="height: 5px;clear:both;"> &nbsp;</div>

                </b-modal>
            </div>
        </div>
    </div>
</template>
<script>

    export default{
        mounted() {
            //if(this.employeedata.last_working_day == '0000-00-00')
                //this.fdata.last_working_day = '';

            this.showoverlay = false;
        },
        props: ['readonly','pageurl','distribution_type','pf_settings'],
        data(){

            return {

                /* start pf signup variables */
                showoverlay : true,
                per_page:10,
                application_lists: [],
                application_loading : false,
                employeesearch:{name:''},
                users : [],
                eligible_pf: 0,
                chosen_emp_id: 0,
                c_flg: 0, // This variable is for reloading public info
                list_title:'',
                loading:'',
                mark_flag:0,
                statusOptions : [
                    { id: 0, text: "Archived" },
                    { id: 1, text: "Draft" },
                    { id: 2, text: "Audited" },
                ],
                approvepass: '',
                incorrectpass: '',
                payrun_delete_msg:'',
                btn_name:'',
                loading:'',

            }
        },
        methods:{
            getDistributionList: function()
            {

                this.application_loading = true;
                axios.get(this.$api_url+'/pf/distribution/list' , {
                    params: {
                        distribution_type:this.distribution_type
                    }
                }).then(function(response){
                if(response.data){
                this.application_lists = response.data;
                }else{
                this.application_lists = [];
                }

                this.application_loading = false;

                }.bind(this));
            },
            showDeleteModal: function(pageflg)
            {
                //this.loading = 'true';
                this.distribution_id=pageflg;
                //this.$bvModal.show('delete-modal');
                this.approvepass="";
                this.$bvModal.show('delete-payrun-modal');
                this.payrun_delete_msg="Are you sure to delete this distribution ?";
                this.btn_name="Delete";
            },

            showConfirmModal: function(pageflg,flag)
            {
                //this.loading = 'true';
                this.mark_flag = flag;
                this.distribution_id=pageflg;
                //this.$bvModal.show('confirm-modal');
                this.approvepass="";
                if(flag==2)
                {
                    this.payrun_delete_msg="Are you sure to mark this distribution as Audited ?";
                    this.btn_name="Mark as Audited";
                }
                if(flag==1)
                {
                    this.payrun_delete_msg="Are you sure to mark this distribution as Draft ?";
                    this.btn_name="Mark as Draft";
                }

                this.$bvModal.show('confirm-payrun-modal');
            },
            updateDistribution:function(pageflg)
            {

                if(this.approvepass == '')
                {
                    this.$bvToast.toast('Password is required', {
                        title: `Warning`,
                        variant: 'danger',
                        solid: true
                    });
                    return ;
                }
                this.loading='load';

                let formData = new FormData();
                formData.append('distribution_id', pageflg);
                formData.append('status', this.mark_flag);

                if(this.approvepass!='')
                 {
                     var pass=this.approvepass;
    			     this.loading='load';
                     formData.append('pass',pass);
                 }


                axios.post(this.$api_url+'/pf/distribution/update', formData)
                    .then(function (response)
                    {

                        this.loading='';
                        this.$bvModal.hide('confirm-payrun-modal');
                        this.loan_entity_id='';
                        this.loan_update_status = '';
                        this.loading='';
                        this.getDistributionList();
                        if(response.data.success == true)
                        {
                            this.$bvToast.toast('Success!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                        }
                        else
                        {
                            this.$bvToast.toast(response.data.message, {
                                title: `error`,
                                variant: 'danger',
                                solid: true
                            });

                        }
                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },

            deleteDistribution:function(pageflg)
            {

                if(this.approvepass == '')
                {
                    this.$bvToast.toast('Password is required', {
                        title: `Warning`,
                        variant: 'danger',
                        solid: true
                    });
                    return ;
                }


                this.loading='load';

                let formData = new FormData();
                formData.append('distribution_id', pageflg);
                if(this.approvepass!='')
                 {
                     var pass=this.approvepass;
    			     this.loading='load';
                     formData.append('pass',pass);
                 }


                axios.post(this.$api_url+'/pf/distribution/delete', formData)
                    .then(function (response)
                    {

                        this.loading='';
                        this.$bvModal.hide('delete-payrun-modal');
                        this.loan_entity_id='';
                        this.loan_update_status = '';
                        this.loading='';
                        this.getDistributionList();
                        if(response.data.success == true)
                        {
                            this.$bvToast.toast('Success!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                        }
                        else
                        {
                            this.$bvToast.toast(response.data.message, {
                                title: `error`,
                                variant: 'danger',
                                solid: true
                            });

                        }
                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },


        },
        created: function(){
            if(this.distribution_type==1)
            {
                this.list_title = 'Company Profit Distribution List';
            }
            else if(this.distribution_type==2)
            {
                this.list_title = 'Company Forfeiture Distribution List';
            }
            else if(this.distribution_type==3)
            {
                this.list_title = 'Company Forfeiture Reclaim List';
            }
            this.getDistributionList();

        }

    }

</script>


<style scoped>
.distribution_delete_show.show {
	position: relative !important;
}
.distribution_delete_show .dropdown-menu.action-dropdown-menu.show {
	top: 0 !important;
}

</style>
